module.exports = __webpack_public_path__ + "img/icon_auth_two.37c7cbe9.png";